import React from "react";
import "./Aletheion.css";
import PageHeader from "../../../components/headers/PageHeader";
import wave from "../../../assets/Images/waves/mix_wave.jpg";

export default function Aletheion() {
    return (
        <div className="aletheion-page">
            <PageHeader
                mediaSrc={wave}
                mediaType="image"
                subtitle="SEND Automation Platform"
                title="Aletheion™"
            />

            <section className="aletheion-section">
                <h2>Preclinical SEND automation built for regulatory data teams</h2>

                <article className="aletheion-box">
                    <p>
                        Aletheion™ is a preclinical SEND automation platform designed
                        to help sponsors, CROs, and nonclinical laboratories transform
                        study data into structured, validated, submission-ready SEND
                        packages. It supports efficient domain processing, metadata
                        management, validation workflows, and documentation generation
                        for regulatory submission readiness.
                    </p>
                </article>
            </section>

            <section className="aletheion-section">
                <h2>What Aletheion™ Supports</h2>

                <article className="aletheion-box">
                    <p>
                        Aletheion™ focuses on the operational and technical challenges
                        involved in SEND dataset generation. It helps teams manage
                        source data, map study variables, generate SEND domains, review
                        outputs, and maintain traceability from raw data to final
                        submission package.
                    </p>

                    <ul className="aletheion-list">
                        <li>Preclinical study data processing and transformation</li>
                        <li>SEND domain generation and structured dataset preparation</li>
                        <li>Controlled terminology alignment and metadata management</li>
                        <li>Define.xml and SDRG / nSDRG preparation support</li>
                        <li>Source-to-SEND mapping review and traceability</li>
                        <li>Validation workflow support for submission readiness</li>
                        <li>Automated quality checks and review-driven issue tracking</li>
                    </ul>
                </article>
            </section>

            <section className="aletheion-section">
                <h2>Core Capabilities</h2>

                <div className="aletheion-boxGrid">
                    <article className="aletheion-box">
                        <h3>Data Ingestion</h3>
                        <p>
                            Import and normalize source data from SAS datasets, CSV,
                            Excel, text files, laboratory exports, and other structured
                            preclinical data sources.
                        </p>
                    </article>

                    <article className="aletheion-box">
                        <h3>SEND Mapping</h3>
                        <p>
                            Support domain-level mapping between raw study variables
                            and SEND-compliant structures with reviewable transformation
                            logic.
                        </p>
                    </article>

                    <article className="aletheion-box">
                        <h3>Domain Processing</h3>
                        <p>
                            Generate and review SEND domains using repeatable workflows
                            that help reduce manual effort and improve consistency
                            across studies.
                        </p>
                    </article>

                    <article className="aletheion-box">
                        <h3>Validation Readiness</h3>
                        <p>
                            Support dataset review, conformance checks, issue tracking,
                            and preparation of clean deliverables for final regulatory
                            packaging.
                        </p>
                    </article>
                </div>
            </section>

            <section className="aletheion-section">
                <h2>Designed for Preclinical Study Types</h2>

                <article className="aletheion-box">
                    <p>
                        Aletheion™ is intended for SEND-focused preclinical operations
                        and can support workflows across standard and specialized
                        nonclinical study types.
                    </p>

                    <ul className="aletheion-list">
                        <li>Single-dose toxicity studies</li>
                        <li>Repeat-dose toxicity studies</li>
                        <li>Safety pharmacology studies</li>
                        <li>Carcinogenicity studies</li>
                        <li>Developmental and reproductive toxicology studies</li>
                        <li>Toxicokinetic studies</li>
                        <li>Juvenile toxicity studies</li>
                        <li>Specialized nonclinical studies</li>
                    </ul>
                </article>
            </section>

            <section className="aletheion-section">
                <h2>Why Aletheion™</h2>

                <article className="aletheion-box">
                    <p>
                        Traditional SEND conversion can become time-consuming when
                        study data is fragmented across multiple files, formats, and
                        laboratory systems. Aletheion™ helps standardize the process so
                        teams can work with greater consistency, transparency, and
                        control.
                    </p>

                    <ul className="aletheion-list">
                        <li>Reduces repetitive manual dataset preparation effort</li>
                        <li>Improves traceability between source data and SEND outputs</li>
                        <li>Supports consistent domain-level review across studies</li>
                        <li>Helps improve turnaround time for submission-ready packages</li>
                        <li>Strengthens internal SEND governance and quality oversight</li>
                    </ul>
                </article>
            </section>
        </div>
    );
}